import { DocumentTypes } from 'client/Interfaces/Draft/DraftInterface'

import * as api from '../../../api/document'
import { InvoiceListItemInterface, InvoiceStatus } from '../../invoices/InvoiceListItemInterface'

export const isInvoiceDraftOrUnsaved = async (documentId?: number, documentType?: DocumentTypes) => {
  if (!documentId || !documentType) {
    return true
  }
  const type = documentType === DocumentTypes.CREDITNOTE ? DocumentTypes.CREDITNOTE : DocumentTypes.INVOICE
  const invoice = (await api.getDocumentV1(type, documentId)) as InvoiceListItemInterface

  return !(invoice && invoice?.status) || (invoice && invoice.status && invoice.status.status === InvoiceStatus.DRAFT)
}
